import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private environment: { endpoint: string, endpointversion: string } | null = null;
  private environmenturl: URL | null = null;
  private googleClientId: string | null = null;
  private config$: Observable<any> | null = null;

  constructor(private httpClient: HttpClient) { }

  loadConfig(): Observable<any> {
    if (!this.config$) {
      this.config$ = this.httpClient.get('/cfg/app-configs.json').pipe(
        tap((data: any) => {
          this.environment = { endpoint: data['endpoint'], endpointversion: data['endpointversion'] };
          this.environmenturl = new URL(data['endpointversion'], data['endpoint']);
          localStorage.setItem('environment', this.environmenturl.toString());
          this.googleClientId = data['googleClientId'] || null;
        }),
        shareReplay(1)
      );
    }
    return this.config$;
  }

  getEnvironment(): { endpoint: string, endpointversion: string } | null {
    return this.environment;
  }

  getEnvironmentUrl(): URL | null {
    return this.environmenturl;
  }

  getGoogleClientId(): string | null {
    return this.googleClientId;
  }
}
